import FallbackComponent from "@/components/FallbackComponent";
import Loading from "@/components/Loading";
import { useGetValveReport } from "@/reports/api";
import useRole from "@/auth/hooks/useRole";
import ReportForm from "@/reports/components/ReportForm";
import {
  isSafetyValveReport,
  locationSchema,
} from "@/reports/types/SafetyValveReport";
import { useCallback } from "react";
import { withErrorBoundary } from "react-error-boundary";
import { useNavigate, useParams } from "react-router-dom";
import { FORM_ACTION } from "@/reports/config/formActionType";
import { ReportType } from "@/reports/types/Api";

interface ViewReportProps {
  reportType?: ReportType;
}

const View = ({ reportType = "SAFETY_VALVE" }: ViewReportProps) => {
  const navigate = useNavigate();
  const { isViewer } = useRole();
  const { location: locationParam, id: idParam } = useParams();
  const location = locationSchema.parse(locationParam);
  const id = {
    value: String(idParam),
    onServer: true,
  };

  const { data: defaultValues, isLoading } = useGetValveReport(
    id,
    location,
    isViewer,
    reportType
  );

  const onCancel = useCallback(() => {
    if (reportType === "MANUAL_VALVE") {
      navigate("/manual-valve-reports");
    } else if (reportType === "SAFETY_VALVE") {
      navigate("/safety-valve-reports");
    } else {
      navigate("/");
    }
  }, [navigate, reportType]);

  const renderTitle = () => {
    if (!defaultValues) return "Valve Report";
    return isSafetyValveReport(defaultValues)
      ? `${defaultValues.vCustomer ?? ""}_${defaultValues.vPSVNumber ?? ""}`
      : `${defaultValues.vCustomer ?? ""}_${defaultValues.vVVNumber ?? ""}`;
  };

  if (isLoading) return <Loading />;

  return (
    <ReportForm
      onCancel={onCancel}
      defaultValues={defaultValues}
      title={renderTitle()}
      formActionType={FORM_ACTION.VIEW}
      reportType={reportType}
    />
  );
};

export default withErrorBoundary(View, {
  FallbackComponent,
});
